<template>
 <div class="operateManage_container">
   <div class="overal_bg"></div>
   <main class="index_page" :class="{ isThinStyle: isThin }">
     <div class="left_mod">
       <left-mod></left-mod>
     </div>
     <div class="center_mod">
       <center-mod></center-mod>
     </div>
     <div class="right_mod">
       <right-mod></right-mod>
     </div>
   </main>
 </div>
</template>

<script>
import leftMod from '@/modules/operateMangeComponents/leftMod';
import rightMod from '@/modules/operateMangeComponents/rightMod';
import centerMod from '@/modules/operateMangeComponents/centerMod';
import {dateFormat} from "utils/tools";
import { setPageActive } from "@/utils/platformmonitor.js";
export default {
  name: 'operateManageMod',
  components: {leftMod,rightMod,centerMod},
  data() {
    return {
      pageInfo: 'operateManageMod.vue',
      computedName: '超低回顾首页组件',
      styleType: '',
      isThin: bmeConfig.isThin,
    }
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  mounted() {
    setPageActive("超低回顾","open",true)
  },
  methods:{
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance.computedName,
          sourcePage: instance.pageInfo,
          time: time,
          msg: msg
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
  }
}
</script>

<style scoped lang="scss">
.operateManage_container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  pointer-events: auto;
  .overal_bg {
    position: absolute;
    left: 15px;
    top: 120px;
    bottom: 15px;
    right: 1px;
    background-image: url("/static/images/common/mask_green.png");
    background-size: 100% 100%;
    background-repeat: "no-repeat";
    z-index: -1;
  }
}

.index_page {
  height: 100%;
  position: relative;

  .left_mod {
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 160px;
    width: 24%;
    height: 800px;
    padding-left: 50px;
  }

  .center_mod {
    position: absolute;
    left: 24%;
    top: 0;
    margin-top: 160px;
    width: 52%;
    height: 800px;
  }

  .right_mod {
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 160px;
    width: 24%;
    height: 800px;
    padding-right: 50px;
    box-sizing: border-box;
  }
}
.isThinStyle {
  transform: scale(1, 0.8) !important;
}
</style>
